<template>
    <el-dialog
        title="补录"
        width="75%"
        @close="closeAddDialog"
        :close-on-click-modal="false"
        class="leader-dialog complementDialog"
        :visible.sync="dialogFormVisible"
    >
        <div style="position: absolute; top: 5%;right: 10%; color: #fa3a3a;font-size: 18px;">(所有电量(有功、电量)都得填，不能填0!)</div>
        <el-form
            ref="addBLForm"
            class="leader-style-form"
            :model="addBLForm"
        >
            <el-row :gutter="20">
                <el-col :span="12">
                    <el-form-item label="当前采集点" label-width="150px">
                        <el-input
                            maxlength="20"
                            v-model="treePointName"
                            disabled
                        ></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item
                        label="时间"
                        prop="upload_time"
                        label-width="150px"
                        :rules="[
                            {
                                required: true,
                                message: '请选择开始时间',
                                trigger: 'blur'
                            }
                        ]"
                    >
                        <el-date-picker
                            v-model="addBLForm.upload_time"
                            align="right"
                            type="datetime"
                            style="width: 100%"
                            :clearable="false"
                            placeholder="选择时间"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            :picker-options="pickerOptions"
                        ></el-date-picker>
                    </el-form-item>
                </el-col>
                <el-col :span="12" v-for="(item, index) in pointDesignInfos" :key="index">
                    <el-form-item
                        :label="item.column_desc"
                        :prop="item.column_name"
                        label-width="150px"
                        :rules="[
                            {
                                required: false,
                                message: '请输入数据',
                                trigger: 'blur'
                            }
                        ]"
                    >
                        <el-input
                            maxlength="10"
                            v-model="addBLForm[item.column_name]"
                            autocomplete="off"
                            v-Int.float
                            @onblur="addBLForm[item.column_name] = $event.target.value"
                        ></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>

        <div slot="footer" class="dialog-footer"> 
            <el-button
                v-loading="saveLoading"
                :disabled="saveLoading"
                class="leader-common-button"
                @click="submitCollectionPoint"
            >保 存
            </el-button
            >
             <el-button @click="cancelDialog" class="leader-common-button"
            >取 消
            </el-button
            >
        </div>
    </el-dialog>
</template>
<script>
    import * as api from "@/http/collection-point-design.js";
    import {
        getCodelistByKind,
        getPointList,
        getPointClassColumnKindList,
        getPointClassMainSelect,
        getPointClassMainDetail,
        getPointsList,
        dataRepairData
    } from "@/http/api.js";
    import Tree from "@/comon/components/tree.vue";
    import { getBWGPointList, getFPointList } from "@/http/collection-point-design.js";

    export default {
        components: {
            "me-tree": Tree
        },
        props: {
            dialogFormVisible: {
                type: Boolean,
                default: false
            },
            dialogType: {
                type: String,
                default: "add"
            },
            treeId: {
                type: String
            },
            treePId: {
                type: String
            },
            treePointName: {
                type: String
            },
            parentPointClassId: {
                type: String
            },
            pointDesignInfos: {
                type: Array
            }
        },
        watch: {
            dialogFormVisible(newVal) {
                if (newVal === true) {
                    this.getDocId(this.treeId);
                    this.getFrequencyList();
                    this.getPointType();
                    this.getPointClassList();
               
                    if (this.dialogType !== "add") {
                        // 修改
                        this.getFPointList(this.treeId);
                        this.getAccountList(this.treeId);
                        this.getInfoById(this.treeId);
                        this.getPointsList();
                        if (
                            this.parentPointClassId != null &&
                            this.parentPointClassId != "" &&
                            this.parentPointClassId != undefined
                        ) {
                            this.getPointClassColumnKindList(
                                this.parentPointClassId
                            );
                        }
                    } else {
                        // 新增
                        this.getFPointList();
                        this.addComForm.pointDesignInfos = [];
                        this.getAccountList(this.treeId, true);
                        this.getPointsList();
                        api.getInfoById({
                            point_id: this.treeId
                        }).then(res => {
                            if (res && res.error_code === "0") {

                                this.addComForm.p_point_name =
                                    res.bus_json.point_name;
                                this.addComForm.p_point_id = res.bus_json.point_id;
                                this.addComForm.elec_customer_id = res.bus_json.elec_customer_id;
                                this.addComForm.switchList = [
                                    {
                                        column_name: "",
                                        switch1_name: "",
                                        switch0_name: ""
                                    }
                                ];
                            }
                            this.getBWGPointList(this.addComForm.point_class_id);
                        });
                        this.$nextTick(() => {
                            this.$refs["addComForm"].clearValidate();
                            // this.addComForm.point_class_id = this.parentPointClassId;
                            // this.getPointClassColumnKindList(
                            //     this.addComForm.point_class_id
                            // );
                        });
                    }
                }
            }
        },
        data() {
            return {
                addBLForm: {
                    point_id: "",
                    upload_time: null,
                },
                addComRules: {
                    
                },
                unitList: [],
                numberList: [],
                frequencyList: [],
                saveLoading: false,
                point_type_list: [],
                point_types: [],
                point_f: [],
                point_bwg: [],
                pv_types: [], //光伏类型
                pointDialogVisible: false,
                treeList: [],
                defaultPropsPoint: {
                    children: "childList",
                    label: "point_name"
                },
                defaultCheckKeys: [],
                defaultExpandedKeys: [], //默认展开的层数
                kinds: [],
                del_pIDs: [],
                classSelects: [],
                pointList1111: [],
                pointClassMainId: ""
            };
        },
        methods: {
            // 获得反向采集点列表
            getFPointList(selectId) {
                api.getFPointList({ point_id: selectId }).then(res => {
                    if (res && res.error_code === "0") {
                        //this.point_type_list = res.bus_json;
                        this.point_f = res.bus_json;
                        //console.log('#' + JSON.stringify(res.bus_json));
                    }
                });
            },
            // 获得并网柜采集点列表
            getBWGPointList(point_class_id) {
                if (point_class_id == "1689906136465186816") {
                    point_class_id = "1658026900632879104";
                } else if (point_class_id == "021") {
                    point_class_id = "020";
                } else if (point_class_id == "022") {
                    point_class_id = "021";
                } else if (point_class_id == "023") {
                    point_class_id = "022";
                }
                api.getBWGPointList({ point_class_id: point_class_id }).then(res => {
                    if (res && res.error_code === "0") {
                        //this.point_type_list = res.bus_json;
                        this.point_bwg = res.bus_json;
                        //console.log('#' + JSON.stringify(res.bus_json));
                    }
                });
            },
            // 采集点类型
            getPointClassList() {
                api.getPointClassList().then(res => {
                    if (res && res.error_code === "0") {
                        this.point_type_list = res.bus_json;
                    }
                });
            },
            // 关联的电表id
            getPointsList() {
                this.pointList1111 = [];
                getPointsList().then(res => {
                    if (res && res.error_code === "0") {
                        this.pointList1111 = res.bus_json;
                    }
                });
            },
            // 获得反向采集点列表
            getFPointList(selectId) {
                api.getFPointList({ point_id: selectId }).then(res => {
                    if (res && res.error_code === "0") {
                        //this.point_type_list = res.bus_json;
                        this.point_f = res.bus_json;
                        //console.log('#' + JSON.stringify(res.bus_json));
                    }
                });
            },
            /**
             * 获取节点信息
             * params {selectId<String>}  选中树节点ID
             */
            getInfoById(selectId) {
                api.getInfoById({
                    point_id: selectId
                }).then(res => {
                    if (res && res.error_code === "0") {
                        this.addComForm.point_name = res.bus_json.point_name;
                        this.addComForm.position = res.bus_json.position;
                        this.addComForm.p_point_name = res.bus_json.p_point_name;
                        this.addComForm.p_point_id = res.bus_json.p_point_id;
                        // this.addComForm.doc_id = res.bus_json.doc_id;
                        this.addComForm.factory_no = res.bus_json.factory_no;
                        this.addComForm.elec_customer_account_id =
                            res.bus_json.elec_customer_account_id;
                        this.addComForm.collect_frequency =
                            res.bus_json.collect_frequency;
                        this.addComForm.point_class_id =
                            res.bus_json.point_class_id;
                        this.addComForm.point_type = res.bus_json.point_type;
                        this.addComForm.pv_type = res.bus_json.pv_type;
                        // this.addComForm.jc_rate = res.bus_json.jc_rate;
                        this.addComForm.pointDesignInfos =
                            res.bus_json.pointDesignInfos;
                        this.addComForm.protectList = res.bus_json.protectList;
                        this.addComForm.switchList = res.bus_json.switchList;
                        this.addComForm.f_to_point_id = res.bus_json.f_to_point_id;
                        this.addComForm.bwg_point_id = res.bus_json.bwg_point_id;
                        this.addComForm.rated_p = res.bus_json.rated_p;
                        this.addComForm.model = res.bus_json.model;
                        this.addComForm.capacity = res.bus_json.capacity;
                        this.addComForm.relation_point_id = res.bus_json.relation_point_id;
                        if (
                            this.addComForm.point_class_id != null &&
                            this.addComForm.point_class_id != undefined &&
                            this.addComForm.point_class_id != ""
                        ) {
                            this.getPointClassColumnKindList(
                                this.addComForm.point_class_id
                            );
                            this.getPointClassMainSelect(
                                this.addComForm.point_class_id
                            );
                        }
                    }
                    this.getBWGPointList(this.addComForm.point_class_id);
                });
            },
            /**
             * 提交新增采集点信息
             */
            submitCollectionPoint() {
                this.$refs["addBLForm"].validate(valid => {
                    if (valid) {
                        this.saveLoading = true;
                        let params = {
                            ...this.addBLForm,
                            point_id: this.treeId
                        };
                        dataRepairData(params).then(res => {
                            if (res && res.error_code == "0") {
                                this.$message({
                                    message: res.error_msg,
                                    type: "success"
                                });
                                this.$emit("collectionPointAddCb");
                                this.dialogFormVisible = false;
                                this.addBLForm = {
                                    point_id: "",
                                    upload_time: null,
                                }
                            } else {
                                // this.dialogFormVisible = false;
                            }
                            this.saveLoading = false;
                        });
                    }
                });
            },
            /**
             * 获得采集单元下拉
             */
            getDocId(selectId) {
                api.getDocId({
                    point_id: selectId
                }).then(res => {
                    if (res && res.error_code === "0") {
                        this.unitList = res.bus_json;
                    }
                });
            },
            /**
             * 获得户号下拉
             *params {selectId<String>} tree id
             *params {loadingStatus<Boolean>} 是否关闭loading状态
             */
            getAccountList(selectId, loadingStatus) {
                api.getAccountList({
                    point_id: selectId
                }).then(res => {
                    if (res && res.error_code === "0") {
                        this.numberList = res.bus_json;
                    }
                });
            },
            /**
             * 获取频率下拉
             */
            getFrequencyList() {
                getCodelistByKind({
                    code_kind: "collect_frequency"
                }).then(res => {
                    if (res && res.error_code === "0") {
                        this.frequencyList = res.bus_json[0].codelists;
                    }
                });
            },
            /**
             * 获取用途下拉
             */
            getPointType() {
                getCodelistByKind({
                    code_kind: "point_type;pv_type"
                }).then(res => {
                    if (res && res.error_code === "0") {
                        this.point_types = res.bus_json[0].codelists;
                        this.pv_types = res.bus_json[1].codelists;
                    }
                });
            },
            // 获取数据项名称
            getPointClassMainSelect(pointClass_id) {
                getPointClassMainSelect({ pointClassId: pointClass_id }).then(
                    res => {
                        if (res && res.error_code === "0") {
                            this.classSelects = res.bus_json;
                        }
                    }
                );
            },
            // 获取分类的接口
            getPointClassColumnKindList(point_class_id) {
                getPointClassColumnKindList({ point_class_id }).then(res => {
                    if (res && res.error_code === "0") {
                        this.kinds = res.bus_json;
                    }
                });
            },
            /**
             * 获得采集点树列表
             */
            getPointList() {
                getPointList().then(res => {
                    if (res && res.error_code === "0") {
                        this.treeList = res.bus_json;
                        this.$nextTick(() => {
                            this.$refs.myTree.$refs.tree.setCurrentKey(
                                this.addComForm.p_point_id
                            );
                        });
                    }
                });
            },
            handleNodePPointClick(point) {
                this.addComForm.p_point_id = point.point_id;
                this.addComForm.p_point_name = point.point_name;
            },
            closeDialogPPoint() {
                this.pointDialogVisible = false;
            },
            cancelDialog() {
                //console.log("asdasd")
                this.del_pIDs = [];
                this.pointClassMainId = "";
                this.dialogFormVisible = false;
            },
            /**
             * 关闭弹窗回调函数
             */
            closeAddDialog() {
                //console.log("@@@@@")
                this.addBLForm = {
                    point_id: "",
                    upload_time: null,
                }
                this.$refs["addBLForm"].clearValidate();
                //this.$refs["addComForm"].resetFields();
                //this.$refs["addComForm"].clearValidate();
                this.$emit("update:dialogFormVisible", this.dialogFormVisible);
            }
        }
    };
</script>
<style lang="scss" scoped>
    .leader-style-form .el-form-item {
        margin-right: 0px !important;
    }
    .el-time-panel__btn.confirm{
        width: auto;
    }
    .tip_col {
        text-align: right;
        color: #fa3a3a;
        line-height: 2.083rem;
    }

    .line_height input {
        line-height: 1;
    }
</style>
